// User Guide Video Configuration
// =============================
// 
// This file contains the configuration for the user guide video.
// To update the video:
// 1. Upload the new video to api.video
// 2. Copy the video ID from the api.video dashboard  
// 3. Update the video entry below with the new details
// 4. Deploy the application

import { IUserGuideVideo } from './userGuideTypes';

export const USER_GUIDE_VIDEOS: IUserGuideVideo[] = [
    {
        id: 'vi3QkwEyfLD1w6GWZB8VC8uI',
        title: 'MSI Seascape - Demonstration',
        description: 'Complete demonstration of MSI Seascape platform features and capabilities. This comprehensive video covers the main interface, navigation, search functionality, portfolio management, map features, and data export capabilities.',
        videoUrl: 'https://embed.api.video/vod/vi3QkwEyfLD1w6GWZB8VC8uI',
        thumbnail: 'https://vod.api.video/vod/vi3QkwEyfLD1w6GWZB8VC8uI/thumbnail.jpg',
        duration: ''
    }
];